// extracted by mini-css-extract-plugin
export var icon = "_5o-1";
export var subtext = "_5o-0";